module.exports = __webpack_public_path__ + "img/understanding-my-data.208046be.png";